// Best Buy open-box rows carry the cheapest condition on the store's shelf
// (Excellent / Good / Fair); unknown values fall back to the raw text.
const OPEN_BOX_CONDITION_KEYS: Record<string, string> = {
  excellent: "card.openBoxExcellent",
  good: "card.openBoxGood",
  fair: "card.openBoxFair",
};

export const getOpenBoxConditionLabel = (
  condition: string | null | undefined,
  t: (key: string) => string,
): string => {
  const raw = condition?.trim() || "";
  if (!raw) return "";
  const key = OPEN_BOX_CONDITION_KEYS[raw.toLowerCase()];
  return key ? t(key) : raw;
};

// Badge text for a Best Buy open-box row: condition, price and % off when known.
export const getOpenBoxBadgeText = (
  product: { openBoxCondition?: string; openBoxDiscountPercentage?: number },
  latestOpenBoxPrice: number,
  formatPrice: (price: number) => string,
  t: (key: string, params?: Record<string, string | number>) => string,
): string => {
  const condition = getOpenBoxConditionLabel(product.openBoxCondition, (key) => t(key));
  const pct = product.openBoxDiscountPercentage;
  if (latestOpenBoxPrice > 0) {
    if (typeof pct === "number") {
      return condition
        ? t("card.openBoxConditionPriceOff", { condition, price: formatPrice(latestOpenBoxPrice), percent: pct })
        : t("card.openBoxPriceOff", { price: formatPrice(latestOpenBoxPrice), percent: pct });
    }
    return t("card.openBoxPrice", { price: formatPrice(latestOpenBoxPrice) });
  }
  return condition ? t("card.openBoxCondition", { condition }) : t("products.openBoxLabel");
};

// Open-box rows are stored as "<sku>-ob" so they don't collide with the
// new-condition row; anything that asks Best Buy about the item (nearby stock,
// search links) needs the real SKU.
export const getRetailerLookupSku = (product: { sku?: string; baseSku?: string; openBox?: boolean }): string => {
  if (product.baseSku) return product.baseSku;
  const sku = product.sku || "";
  return product.openBox && sku.endsWith("-ob") ? sku.slice(0, -3) : sku;
};
